import { render, staticRenderFns } from "./Desparasitacion.vue?vue&type=template&id=6596ede8&"
import script from "./Desparasitacion.vue?vue&type=script&lang=js&"
export * from "./Desparasitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports